import { addMonths } from 'date-fns';

import { INVOICE_STATUS } from 'utils/GeneratedApi';

export const DEFAULT_COUNTRY_CALLING_CODE = '+47';
export const USER_PROFILE_TAG = 'userProfile';

export const MEMBER_CONSENTS_TAG = 'memberConsents';
export const MEMBER_LEDGER_TAG = 'memberLedger';
export const MEMBER_INVOICES_TAG = 'memberInvoices';
export const MEMBER_COMMUNICATIONS_TAG = 'memberCommunications';
export const COMMUNICATION_EMAIL_LIST_TAG = 'communicationEmailList';
export const COMMUNICATION_WIDGET_TAG = 'communicationWidget';

export const MAX_PRODUCT_QUANTITY_LIMIT = 10;

// We need to hide the optional product, when the quantity is set to 0
export const HIDE_PRODUCT_QUANTITY = 0;

// We need to allow to purchase unlimited optional product, when the quantity is set to -1
export const UNLIMITED_PRODUCT_QUANTITY = -1;

export const PAYMENT_STATUS_COLORS = {
  PAID: 'bg-green-500',
  DUE: 'bg-yellow-500',
};

export const PRODUCT_QUANTITY_RANGE_OPTIONS = [
  { label: 'Hide', value: HIDE_PRODUCT_QUANTITY },
  { label: 'Unlimited', value: UNLIMITED_PRODUCT_QUANTITY },
  ...Array.from({ length: MAX_PRODUCT_QUANTITY_LIMIT }, (_, i) => ({
    label: `${i + 1}`,
    value: `${i + 1}`,
  })),
];

export const ONE_SECOND_IN_MILLISECONDS = 1000; // 1 second in milliseconds

export const GRAPH_COLORS = {
  BLUE: 'rgba(42, 131, 235, 0.7)', // Blå
  GREEN: 'rgba(39, 191, 29, 0.7)', // Grønn
  ORANGE: 'rgba(235, 101, 42, 0.7)', // Oransje
  PURPLE: 'rgba(183, 157, 255, 0.7)', // Lilla
  YELLOW: 'rgba(246, 243, 96, 0.7)', // Gul
  BRIGHT_MAGENTA: 'rgba(232, 76, 154, 0.7)', // Lys magenta
  MUTED_SLATE_GRAY: 'rgba(109, 127, 129, 0.7)', // Muttet sølv
  SOFT_CORAL_PINK: 'rgba(255, 182, 193, 0.7)', // Lys rosa
  DEEP_TEAL: 'rgba(26, 102, 127, 0.7)', // Dyp teal
  GOLDENROD: 'rgba(225, 168, 37, 0.7)', // Gyllenrod
  // LIGHT_GRAY: 'rgba(245, 249, 255, 0.7)', // Lys grå
  // BLACK: 'rgba(27, 28, 27, 0.7)', // Sort
  // WHITE: 'rgba(255, 255, 255, 0.7)', // Hvit
};

export const SECONDS_IN_A_HOUR = 3600;
export const SECONDS_IN_A_DAY = 24 * SECONDS_IN_A_HOUR;

export const SIX_MONTHS = 6;
export const ONE_DAY = 1;

// Calculate max date as 6 months from today
export const maxFutureActivationStartDate = addMonths(new Date(), SIX_MONTHS);
export const minFutureActivationStartDate = new Date();

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_VIPPS = 3;

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_NETS_STRIPES = 1;

export const MINIMUM_NEXT_RENEWAL_DATE_EXTENSION_FOR_EXTERNAL = 1;

export const DATE_TYPE_CUSTOM_PROPERTIES = ['mufcExpiration'];

export const DEFAULT_DOWNLOAD_FORMAT = 'xlsx';

export const DOWNLOAD_FORMAT_OPTIONS = [
  { value: 'xlsx', label: 'XLSX' },
  { value: 'csv', label: 'CSV' },
];

export const MY_PAGE_REFERENCE_FOR_CHECKOUT = 'my-page';

export const DEFAULT_BUY_NEW_SUBSCRIPTION_URL = 'account/subscriptions/buy-new-subscription';

export const DUE_INVOICE_STATUSES = [INVOICE_STATUS.Unpaid, INVOICE_STATUS.OverDue];

// Define fields that should not show the Change button if they already have values
// This is to prevent the group owner from changing the email or phone number
export const HIDDEN_CTA_FIELDS = ['email', 'phone'];

export const IMPORT_SUBSCRIPTIONS_FILE_NAME = 'subscription_import_example_template.xlsx';

export const IMPORT_SUBSCRIPTIONS_HEADERS = [
  'email',
  'fullName',
  'phone',
  'companyName',
  'organizationNo',
  'address',
  'city',
  'country',
  'postCode',
  'packageId',
  'paymentProvider',
  'optionalProductId1',
  'quantity1',
  'optionalProductId2',
  'quantity2',
  'optionalProductId3',
  'quantity3',
  'isPaid',
  'nextRenewalDate',
  'autoRenew',
];

export const IMPORT_SUBSCRIPTIONS_DUMMY_DATA = [
  [
    'dummy.one@example.com',
    'Test Person One',
    '+4791234567',
    'Demo Company ABC',
    '987654321',
    'Test Street 123',
    'Oslo',
    'NO',
    '0150',
    '66',
    'free',
    '1',
    '5',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-15',
    'ja',
  ],
  [
    'dummy.two@example.com',
    'Example User Two',
    '+4745678901',
    'Sample Corp XYZ',
    '974761076',
    'Demo Avenue 456',
    'Bergen',
    'NO',
    '5020',
    '66',
    'invoice',
    '3',
    '2',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-15',
    'ja',
  ],
  [
    'dummy.three@example.com',
    'Sample Name Three',
    '+4798765432',
    'Test Business 123',
    '911986884',
    'Example Road 789',
    'Trondheim',
    'NO',
    '7010',
    '66',
    'external',
    '4',
    '6',
    '',
    '',
    '',
    '',
    'Nei',
    '',
    'Nei',
  ],
  [
    'dummy.four@example.com',
    'Demo Person Four',
    '+4743210987',
    'Dummy Corp 456',
    '995276640',
    'Test Lane 012',
    'Stavanger',
    'NO',
    '4006',
    '67',
    'external',
    '2',
    '7',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-17',
    'ja',
  ],
  [
    'dummy.five@example.com',
    'Test User Five',
    '+4791122334',
    'Sample AS 789',
    '889640782',
    'Demo Path 345',
    'Tromsø',
    'NO',
    '9008',
    '67',
    'external',
    '2',
    '4',
    '',
    '',
    '',
    '',
    'ja',
    '2026-04-17',
    'Nei',
  ],
];

export const REVALIDATION_TIME_IN_SECONDS_INFREQUENTLY_CHANGED_DATA = 60; // 1 minute
export const REVALIDATION_TIME_IN_SECONDS_FREQUENTLY_CHANGED_DATA = 0; // 0 seconds

export const OIDC_ERROR_MAP = {
  'Invalid Grant Errors (1000–1099)': {
    1000: 'no original detail',
    1001: 'authorization code not found',
    1002: 'client mismatch',
    1003: 'authorization code is expired',
    1004: 'grant not found',
    1005: 'grant is expired',
    1006: 'mutual TLS client certificate not provided',
    1007: 'DPoP proof JWT not provided',
    1008: 'authorization code redirect_uri mismatch',
    1009: 'authorization code already consumed',
    1010: 'authorization code invalid (referenced account not found)',
    1011: 'accountId mismatch',
    1012: 'missing DPoP proof JWT',
    1013: 'DPoP proof JWT Replay detected',
    1014: 'DPoP proof key thumbprint does not match dpop_jkt',
    1015: 'backchannel authentication request not found',
    1016: 'backchannel authentication request already consumed',
    1017: 'backchannel authentication request invalid (referenced account not found)',
    1018: 'device code not found',
    1019: 'device code is expired',
    1020: 'device code already consumed',
    1021: 'device code invalid (referenced account not found)',
    1022: 'refresh token not found',
    1023: 'refresh token is expired',
    1024: 'failed x5t#S256 verification',
    1025: 'failed jkt verification',
    1026: 'refresh token invalid (referenced account not found)',
    1027: 'refresh token already used',
    1028: 'PKCE verification failed',
  },
  'Invalid Request Errors (2000–2077)': {
    2000: 'authorization_details is unsupported for this grant_type',
    2001: 'authorization_details is unsupported for this refresh token',
    2002: 'could not find device form details',
    2003: 'xsrf token invalid',
    2004: 'could not find logout details',
    2005: 'could not decode id_token_hint',
    2006: 'client_id does not match the provided id_token_hint',
    2007: 'could not validate id_token_hint',
    2008: 'post_logout_redirect_uri not registered',
    2009: 'client does not have permission to read its record',
    2010: "provided client_id does not match the authenticated client's one",
    2011: "provided client_secret does not match the authenticated client's one",
    2012: 'client does not have permission to update its record',
    2013: 'client does not have permission to delete its record',
    2014: 'this token does not belong to you',
    2015: 'requested grant type is not allowed for this client',
    2016: 'claims parameter should not be combined with response_type none',
    2017: 'could not parse the claims parameter JSON',
    2018: 'claims parameter should be a JSON object',
    2019: 'claims parameter should have userinfo or id_token properties',
    2020: 'claims.userinfo should be an object',
    2021: 'claims.id_token should be an object',
    2022: 'claims.userinfo should not be used since userinfo endpoint is not supported',
    2023: 'claims.userinfo should not be used if access_token is not issued',
    2024: 'invalid max_age parameter value',
    2025: 'openid scope must be requested for this response_type',
    2026: 'openid scope must be requested for this request',
    2027: 'code_challenge_method must be provided',
    2028: 'not supported value of code_challenge_method',
    2029: 'code_challenge must be provided with code_challenge_method',
    2030: 'Authorization Server policy requires PKCE to be used for this request',
    2031: 'unsupported prompt value requested',
    2032: 'prompt none must only be used alone',
    2033: 'invalid requested_expiry parameter value',
    2034: 'requested response_mode is not allowed for this client or request',
    2035: 'requested response_type is not allowed for this client',
    2036: 'missing one of required parameters login_hint_token, id_token_hint, or login_hint',
    2037: 'only one of required parameters login_hint_token, id_token_hint, or login_hint must be provided',
    2038: 'Pushed Authorization Request must be used',
    2039: 'Request Object must be used by this client',
    2040: 'Encrypted Request Objects are not supported by CIBA',
    2041: 'could not decrypt request object',
    2042: 'could not parse Request Object',
    2043: 'Request Object must not contain request or request_uri properties',
    2044: 'request response_type must equal the one in request parameters',
    2045: 'request client_id must equal the one in request parameters',
    2046: "request client_id must equal the authenticated client's client_id",
    2047: 'request client_id mismatch',
    2048: 'unsupported signed request alg',
    2049: 'the preregistered alg must be used in request or request_uri',
    2050: 'Request Object claims are invalid',
    2051: 'could not validate Request Object',
    2052: 'request and request_uri parameters MUST NOT be used together',
    2053: 'Web Message Response Mode Relay Mode is not supported',
    2054: 'request_uri is invalid, expired, or was already used',
    2055: 'requested response_mode is not allowed for the requested response_type',
    2056: 'access token must only be provided using one mechanism',
    2057: 'access tokens must not be provided via query parameter',
    2058: 'invalid authorization header value format',
    2059: 'authorization header scheme must be `DPoP` when DPoP is used',
    2060: '`DPoP` header not provided',
    2061: 'authorization header scheme must be `Bearer`',
    2062: '`DPoP` tokens must be provided via an authorization header',
    2063: 'invalid claims.id_token.acr.values type',
    2064: 'multiple proof-of-posession mechanisms are not allowed',
    2065: 'authorization_details parameter is not supported for this response_type',
    2066: 'could not parse the authorization_details parameter JSON',
    2067: 'authorization_details parameter should be a JSON array',
    2068: 'authorization_details parameter members should be a JSON object',
    2069: 'client_id and client_secret in the authorization header are not properly encoded',
    2070: 'mismatch in body and authorization client ids',
    2071: 'client_secret must be provided in the Authorization header',
    2072: 'client authentication must only be provided using one mechanism',
    2073: 'invalid client_assertion format',
    2074: 'subject of client_assertion must be the same as client_id provided in the body',
    2075: 'client_assertion_type must be provided',
    2076: 'no client authentication mechanism provided',
    2077: 'failed to parse the request body',
  },
  'Invalid Scope Errors (3000–3099)': {
    3000: 'requested scope is not allowed',
  },
  'Invalid Target Errors (4000–4099)': {
    4000: 'only a single resource indicator value is supported for this grant type',
  },
  'Invalid Client Errors (5000–5099)': {
    5000: 'client_id is invalid',
    5001: 'client not found',
    5002: 'unrecognized id_token_hint audience',
    5003: 'invalid secret provided',
    5004: 'audience (aud) must equal the issuer identifier url',
    5005: 'sub (JWT subject) must be provided in the client_assertion JWT',
    5006: 'subject of client_assertion must be the same as client_id provided in the body',
    5007: 'client_assertion_type must be provided',
    5008: 'no client authentication mechanism provided',
    5009: 'the provided authentication mechanism does not match the registered client authentication method',
    5010: 'client certificate was not provided',
    5011: 'client certificate was not verified',
    5012: 'certificate subject value does not match the registered one',
    5013: 'client certificate was not provided',
    5014: 'unregistered client certificate provided',
    5015: 'alg mismatch',
    5016: 'expiration must be specified in the client_assertion JWT',
    5017: 'unique jti (JWT ID) must be provided in the client_assertion JWT',
    5018: 'iss (JWT issuer) must be provided in the client_assertion JWT',
    5019: 'iss (JWT issuer) must be the client_id',
    5020: 'aud (JWT audience) must be provided in the client_assertion JWT',
    5021: 'list of audience (aud) must include the endpoint url, issuer identifier or token endpoint url',
    5022: 'audience (aud) must equal the endpoint url, issuer identifier or token endpoint url',
    5023: 'client assertion tokens must only be used once',
  },
  'Invalid Token Errors (6000–6099)': {
    6000: 'registration access token not found',
    6001: 'initial access token not found',
    6002: 'invalid initial access token value',
    6003: 'access token not found',
    6004: 'access token is not sender-constrained but proof of possession was provided',
    6005: 'token audience prevents accessing the userinfo endpoint',
    6006: 'associated client not found',
    6007: 'associated account not found',
  },
};

export const MAX_INVOICE_BATCH_DOWNLOAD_LIMIT = 2000;

export enum VIPPS_AGREEMENT_STATES {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  STOPPED = 'STOPPED',
  EXPIRED = 'EXPIRED',
}

export const VIPPS_AGREEMENT_STATES_INACTIVE = [
  VIPPS_AGREEMENT_STATES.STOPPED,
  VIPPS_AGREEMENT_STATES.EXPIRED,
];
